// extracted by mini-css-extract-plugin
export default {"Checkout":"Checkout_Checkout__JoiqZ","label_input":"Checkout_label_input__1OrDh"};